window.JAiDOSalesData = {

settings:{

showAfter:5000,

visibleFor:5000,

minDelay:6000,

maxDelay:9000

},

firstNames:[
"Ahmed",
"Muhammad",
"Ali",
"Hassan",
"Hussain",
"Bilal",
"Usman",
"Umer",
"Talha",
"Hamza",
"Saad",
"Awais",
"Danish",
"Shahzaib",
"Arslan",
"Abdullah",
"Huzaifa",
"Zain",
"Ahsan",
"Farhan",
"Kamran",
"Imran",
"Faisal",
"Rizwan",
"Noman",
"Adnan",
"Salman",
"Khurram",
"Waqas",
"Shayan",
"Yasir",
"Umair",
"Sameer",
"Haris",
"Zeeshan",
"Shoaib",
"Taimoor",
"Junaid",
"Shahid",
"Rehan",
"Naveed",
"Mudassir",
"Asad",
"Jawad",
"Irfan",
"Faizan",
"Adeel",
"Sheryar",
"Rameez",
"Ammar",

"Ayesha",
"Fatima",
"Maryam",
"Zainab",
"Hira",
"Komal",
"Mahnoor",
"Laiba",
"Eman",
"Noor",
"Anaya",
"Amna",
"Iqra",
"Mehak",
"Sidra",
"Maham",
"Rabia",
"Alina",
"Sana",
"Saira",
"Hafsa",
"Kinza",
"Kiran",
"Anum",
"Rida",
"Nimra",
"Areeba",
"Muskan",
"Zoya",
"Inaya",
"Minal",
"Hoor",
"Bushra",
"Afreen",
"Aiman",
"Fiza",
"Anosha",
"Saba",
"Maira",
"Sehrish",
"Khadija",
"Aleena",
"Rimsha",
"Rania",
"Sonia",
"Uzma",
"Samina",
"Lubna",
"Farah",
"Nadia"
],

lastNames:[
"Ahmed",
"Ali",
"Khan",
"Malik",
"Raza",
"Hussain",
"Mehmood",
"Tariq",
"Chaudhry",
"Sheikh",
"Siddiqui",
"Qureshi",
"Bhatti",
"Butt",
"Awan",
"Abbasi",
"Farooq",
"Nawaz",
"Javed",
"Akhtar",
"Shah",
"Yousaf",
"Mirza",
"Aslam",
"Iqbal",
"Rasheed",
"Zafar",
"Rehman",
"Saleem",
"Anwar",
"Bukhari",
"Naseer",
"Yaqoob",
"Hashmi",
"Gilani",
"Dar",
"Baig",
"Latif",
"Arif",
"Saeed",
"Rafique",
"Ashraf",
"Mughal",
"Pervaiz",
"Jamal",
"Khalid",
"Munir",
"Nadeem",
"Shafiq",
"Waseem",
"Haroon",
"Yasin",
"Aziz",
"Asghar",
"Sultan",
"Sabir",
"Shabbir",
"Majid",
"Kashif",
"Fayyaz",
"Masood",
"Tanveer",
"Waheed",
"Mahmood",
"Nasir",
"Bashir",
"Hanif",
"Rauf",
"Riaz",
"Sarwar",
"Shaukat",
"Parvez",
"Sohail",
"Nisar",
"Akram",
"Ismail",
"Rana",
"Cheema",
"Sandhu",
"Virk"
],

cities:[
"Lahore",
"Karachi",
"Islamabad",
"Rawalpindi",
"Faisalabad",
"Multan",
"Sialkot",
"Gujranwala",
"Peshawar",
"Hyderabad",
"Bahawalpur",
"Sargodha",
"Abbottabad",
"Quetta",
"Sahiwal",
"Gujrat",
"Rahim Yar Khan",
"Okara",
"Kasur",
"Sheikhupura",
"Mardan",
"Mingora",
"Attock",
"Jhelum",
"Haripur",
"Chiniot",
"Narowal",
"Vehari",
"Khanewal",
"Dera Ghazi Khan",
"Burewala",
"Larkana",
"Sukkur",
"Nawabshah",
"Mirpur",
"Kotli",
"Muzaffarabad",
"Skardu",
"Gilgit",
"Chakwal"
],

times:[
"Just now",
"1 minute ago",
"2 minutes ago",
"4 minutes ago",
"6 minutes ago",
"9 minutes ago",
"12 minutes ago",
"18 minutes ago",
"25 minutes ago",
"34 minutes ago",
"45 minutes ago",
"1 hour ago",
"2 hours ago",
"3 hours ago",
"5 hours ago",
"Yesterday"
]

};